import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from './cn.js';
const taban = 'inline-flex items-center justify-center gap-2 font-medium rounded-lg transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-marka-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-fume-900 disabled:opacity-50 disabled:cursor-not-allowed';
const stiller = {
    birincil: 'bg-marka-500 text-fume-900 hover:bg-marka-600 active:bg-marka-700 shadow-sm',
    ikincil: 'bg-fume-100 text-fume-900 hover:bg-fume-200 active:bg-fume-300 dark:bg-fume-700 dark:text-fume-50 dark:hover:bg-fume-600',
    cizgili: 'border border-fume-300 text-fume-800 hover:bg-fume-50 active:bg-fume-100 dark:border-fume-700 dark:text-fume-100 dark:hover:bg-fume-800',
    sade: 'text-fume-700 hover:bg-fume-100 active:bg-fume-200 dark:text-fume-200 dark:hover:bg-fume-800',
    tehlike: 'bg-red-600 text-white hover:bg-red-700 active:bg-red-800 shadow-sm',
};
const boyutlar = {
    kucuk: 'h-8 px-3 text-sm',
    orta: 'h-10 px-4',
    buyuk: 'h-12 px-6 text-base',
    simge: 'h-9 w-9 p-0',
};
export const Buton = forwardRef(({ stil = 'birincil', boyut = 'orta', className, ...rest }, ref) => {
    return (_jsx("button", { ref: ref, className: cn(taban, stiller[stil], boyutlar[boyut], className), ...rest }));
});
Buton.displayName = 'Buton';
//# sourceMappingURL=buton.js.map